import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Config } from 'src/app/_config/config';
import { FormGroup, FormBuilder } from '@angular/forms';
import __ from 'underscore';
import { DataService } from '../_service/data.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import  *  as  column  from  './columnList.json';
import { ExcelService } from '../_service/excel.service';
import { FilterBaseComponent } from '../_base/filter-base.component';
import { HttpClient } from "@angular/common/http";

declare const Highcharts: any;
declare const $: any;
declare const moment: any;
@Component({
  selector: 'app-digital-desk-activeness',
  templateUrl: './digital-desk-activeness.component.html',
  styleUrls: ['./digital-desk-activeness.component.scss']
})
export class DigitalDeskActivenessComponent extends FilterBaseComponent implements OnInit {
 
  public config:any = new Config();
  public filterForm:FormGroup;
  public totalLeadsData: any;
  loginData: any;
    firstTimeRun: Boolean = true;
    columnName: any;
    public channelList: any = [];
    public outletTypeList: any = [];
    channelName: any = '';
    outletTypeName: any= '';
    pastHoursSelected: any;
    pastHoursSelectedList: any = [];
    pastHoursSelectedStatus: Boolean = true;
    notAttendedSelected: any;
    notAttendedStatus: Boolean = true;

    lessThen30MinSelected: any;
    lessThen30MinStatus: Boolean = true;
  constructor(
  private http: HttpClient,
  private fb: FormBuilder,
  protected dataService: DataService,
  private ExcelService: ExcelService
) {
  super(dataService);

  this.filterForm = this.fb.group({
    zone: [""],
    region: [""],
    parent_group: [""],
    outlet: [""],
start_date: [""],
end_date: [""],
    userType: [""],
  });

}


  ngOnInit() {
    this.loginData = (this.dataService.getCookies('loginData'))? JSON.parse(this.dataService.getCookies('loginData')).acl : JSON.parse(localStorage.getItem('loginData')).acl;

    if(this.loginData.userType === 6) { // TSM/RO
      this.parentStatus = true;
      this.pastHoursSelectedList = [
        {value: 'webform_id, web_form_name', view:'OUTLET'},
        {value: 'business_unit_name', view:'DEALER'}
      ];
      this.pastHoursSelected = 'webform_id, web_form_name';
      this.notAttendedSelected = 'webform_id, web_form_name';
      this.lessThen30MinSelected = 'webform_id, web_form_name';
      this.getAllParent('aa');
  } else if(this.loginData.userType === 8) { // Zonal
      this.regionStatus = true;
      this.parentStatus = true;
      this.pastHoursSelectedList = [
        {value: 'region', view:'REGION'},
        {value: 'webform_id, web_form_name', view:'OUTLET'},
        {value: 'business_unit_name', view:'DEALER'}
      ];
      this.pastHoursSelected = 'region';
      this.notAttendedSelected = 'region';
      this.lessThen30MinSelected = 'region';
      this.getAllRegion('aa');
  } else if(this.loginData.userType === 1) { // Agency or HO
      this.regionStatus = true;
      this.parentStatus = true;
      this.zoneStatus = true;
      this.channelStatus = true;
      this.pastHoursSelectedList = [
        {value: 'zone', view:'ZONE'},
        {value: 'region', view:'REGION'},
        {value: 'webform_id, web_form_name', view:'OUTLET'},
        {value: 'business_unit_name', view:'DEALER'}
      ];
      this.pastHoursSelected = 'zone';
      this.notAttendedSelected = 'zone';
      this.lessThen30MinSelected = 'zone';
      this.getAllZone();
  } else if(this.loginData.userType === 7) { // Agency or HO
    this.regionStatus = true;
    this.parentStatus = true;
    this.zoneStatus = true;
    this.channelStatus = true;
    this.pastHoursSelectedList = [
      {value: 'zone', view:'ZONE'},
      {value: 'region', view:'REGION'},
      {value: 'webform_id, web_form_name', view:'OUTLET'},
      {value: 'business_unit_name', view:'DEALER'}
    ];
    this.pastHoursSelected = 'zone';
    this.notAttendedSelected = 'zone';
    this.lessThen30MinSelected = 'zone';
    this.getAllZone();
} else if(this.loginData.userType === 9){
    this.parentStatus = true;
    this.outletStatus = true;
    this.channelStatus = true;
    this.pastHoursSelectedList = [
      {value: 'webform_id, web_form_name', view:'OUTLET'},
      {value: 'business_unit_name', view:'DEALER'}
    ];
    this.pastHoursSelected = 'webform_id, web_form_name';
    this.notAttendedSelected = 'webform_id, web_form_name';
    this.lessThen30MinSelected = 'webform_id, web_form_name';
    this.getAllChannel("''");
  } else if(this.loginData.userType === 10) { // Zonal manager
    this.regionStatus = true;
    this.parentStatus = true;
    // this.zoneStatus = true;
    this.channelStatus = true;
    this.getAllRegion('aa');
    this.pastHoursSelectedList = [
      {value: 'region', view:'REGION'},
      {value: 'webform_id, web_form_name', view:'OUTLET'},
      {value: 'business_unit_name', view:'DEALER'}
    ];
    this.pastHoursSelected = 'region';
    this.notAttendedSelected = 'region';
    this.lessThen30MinSelected = 'region';
  }  else {
      this.regionStatus = true;
      this.outletStatus = true;
      this.channelStatus = true;
      this.getAllRegion("''");
      this.pastHoursSelectedStatus = false;
      this.notAttendedStatus = false;
      this.lessThen30MinSelected = false;
  }
        
        this.filterForm.patchValue({
            "userType": this.loginData.userType
        })
         this.initializeDateRangePicker();
    this.zoneSetting();
    this.regionSetting();
    this.parentSetting();
    this.outletSetting();
    this.columnSetting();
    this.channelSetting();
    this.outletTypeSetting();
    // this.getAllZone();
    // this.advanceFilter();
  }

  public advanceFilter(){
    if(this.firstTimeRun) {
      this.apiReq = {
          zone:'',
          region:'',
          parent: '',
          outlet: '',
          channel:'',
          outletType: '',
          agl_flag: ''
      }
  }
    this.getTotalLeads();
    this.get30MinTo1HourData();
    this.leadTimeResponseData();
    this.getPost6HourData();
    this.getNotAttended();
    this.firstTimeRun = false;
    this.columnList = column['default'];

  }

  get isFilterApplied(): boolean {
  return (
    this.selectedZone.length > 0 ||
    this.selectedRegion.length > 0 ||
    this.selectedParent.length > 0 ||
    this.selectedOutlet.length > 0 ||
    this.selectedChannel.length > 0 ||
    this.selectedOutletType.length > 0 ||
    !this.isDefaultDateRange()
  );
}

download() {
  if (this.selectedColumn.length === 0) {
      this.dataService.showError('Please select column name.');
  } else {
      this.dataService.startLoader();

  let finalData = {
      one: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      channel: this.channelName,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
      columnList: this.selectedColumn
  }
  this.dataService.post('digitalDesk/downloadDDA', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
         // console.log('download data', res['data']);
         if (res['data'].length) {
          this.ExcelService.exportAsExcelFile(res['data'], 'digital_desk_report');
          } else {
              this.dataService.showError('No Data Found.')
          }      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}
}

  public getTotalLeads(){
    this.dataService.startLoader();
    let finalData = {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
      channel: this.channelName
  }
    this.dataService.post('digitalDesk/totalLeads', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
            this.totalLeadsData = res['data'];
        }
        else{
            this.dataService.showError(res['responseMessage']);
            if(res['responseCode'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        this.dataService.showError(err['responseMessage']);
    })
}


//   public changeValue(event, type){
//     let value = event.target.value;
//     if(type == 'zone'){
//         this.filterForm.controls['region'].setValue('');
//         this.regionList = value ? __.where(this.config.regionList, { ZONE:value }) : this.config.regionList;
//     }
//     else if(type == 'region'){

//     }
// }


  public leadResponseChart(leadType) {
    Highcharts.chart('leadResponse_Time', {
      chart: {
        type: 'column'
      },
      exporting: { enabled: false },
      title: {
          text: ''
      },
      subtitle: {
          text: ''
      },
      accessibility: {
        announceNewData: {
          enabled: true
        }
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        title: {
          text: ''
        }
    
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.y:.2f}%'
          }
        }
      },
    
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
      },
    
      series: [
        {
          name: "",
          colorByPoint: true,
          data: [
            {
              name: "< 30 mins",
              y: (leadType)? parseFloat(leadType.lt30per) : 0,
              drilldown: "< 30 mins"
            },
            {
              name: "30 mins to 1 hr",
              y: (leadType) ? parseFloat(leadType.gt30lt1per): 0,
              drilldown: '30 mins to 1 hr'
            },
            {
              name: "1 hr to 2 hrs",
              y: (leadType) ? parseFloat(leadType.gt1lt2per) : 0,
              drilldown: "1 hr to 2 hrs"
            },
            {
              name: "2 hrs to 4 hrs",
              y: (leadType)? parseFloat(leadType.gt2lt4per): 0,
              drilldown: "2 hrs to 4 hrs"
            },
            {
              name: "4 hrs to 6 hrs",
              y: (leadType)? parseFloat(leadType.gt4lt6per): 0,
              drilldown: "4 hrs to 6 hrs"
            },
            {
              name: "Post 6 hrs",
              y: (leadType)? parseFloat(leadType.gt6per): 0,
              drilldown: "Post 6 hrs"
            },
            {
              name: "Not attended",
              y: (leadType)? parseFloat(leadType.non_attendedper): 0,
              drilldown: "Not attended"
            }
          ]
        }
      ],
    });
}

leadTimeResponseData() {
  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date,
    channel: this.channelName

}
    this.dataService.post('digitalDesk/leadTimeResponse', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
          this.leadResponseChart(res['data'][0])
        }
        else{
            this.dataService.showError(res['responseMessage']);
            if(res['responseCode'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        this.dataService.showError(err['responseMessage']);
    })
}

public getPostSixHours(info) {
  Highcharts.chart('pie-chart', {
    chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
    },
    exporting: { enabled: false },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    tooltip: {
        pointFormat: '{series.name}: <b>{point.y}%</b>'
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y} %'
            }
        }
    },
    series: [{
        name: '',
        colorByPoint: true,
        data: info
    }]
});
}

getPost6HourData() {
  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    filterValue: this.pastHoursSelected,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date,
    channel: this.channelName
}
    this.dataService.post('digitalDesk/postSixHourGraph', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
          this.getPostSixHours(res['data'])
          // this.leadResponseChart(res['data'][0])
        }
        else{
            this.dataService.showError(res['responseMessage']);
            if(res['responseCode'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        this.dataService.showError(err['responseMessage']);
    })
}

public get30minGraphData(info) {
  console.log('data', info)
  Highcharts.chart('zone_chart_upr', {
    chart: {
      type: 'column'
    },
    exporting: { enabled: false },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    accessibility: {
      announceNewData: {
        enabled: true
      }
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      title: {
        text: ''
      }
  
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y}%'
        }
      }
    },
  
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}%</b> of total<br/>'
    },
  
    series: [
      {
        name: "",
        colorByPoint: true,
        data: info
      }
    ]
  });
}

get30MinTo1HourData() {
  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date,
    filterValue: this.lessThen30MinSelected,
    channel: this.channelName
}
    this.dataService.post('digitalDesk/get30MinTo1Hour', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
          // console.log('ress', res);
          this.get30minGraphData(res['data'])
          // this.leadResponseChart(res['data'][0])
        }
        else{
            this.dataService.showError(res['responseMessage']);
            if(res['responseCode'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        this.dataService.showError(err['responseMessage']);
    })
}
public getNotAttendedGraph(info) {
  // console.log('getNotAttendedGraph', info)
  Highcharts.chart('zone_chart_dwn', {
    chart: {
      type: 'column'
    },
    exporting: { enabled: false },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    accessibility: {
      announceNewData: {
        enabled: true
      }
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      title: {
        text: ''
      }
  
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y}%'
        }
      }
    },
  
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}%</b> of total<br/>'
    },
  
    series: [
      {
        name: "Browsers",
        colorByPoint: true,
        data: info
      }
    ]
  });
}

getNotAttended() {
  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    filterValue: this.notAttendedSelected,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date,
    channel: this.channelName
}
    this.dataService.post('digitalDesk/getNotAttended', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
          // console.log('ress', res);
          this.getNotAttendedGraph(res['data'])
          // this.leadResponseChart(res['data'][0])
        }
        else{
            this.dataService.showError(res['responseMessage']);
            if(res['responseCode'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        this.dataService.showError(err['responseMessage']);
    })
}

onChange (value) {
  this.pastHoursSelected = value;
  this.getPost6HourData();
}

onChangenotAttended (value) {
  this.notAttendedSelected = value;
  this.getNotAttended();
}
onChangeLessThen30Min (value) {
  this.lessThen30MinSelected = value;
  this.get30MinTo1HourData();
}

public clearFilter() {
    this.dataService.removeCookies("hyperLocalFilter", "");

     this.selectedZone = [];
  this.selectedRegion = [];
  this.selectedParent = [];
  this.selectedChannel = [];
  this.selectedOutlet = [];
  this.selectedOutletType = [];

    window.location.reload();
  }
}
